import { useLocation, useNavigate } from 'react-router-dom';

export const useSearchParamsUpdater = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getParam = (key) => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  const setParam = (key, value, options = { replace: true }) => {
    const params = new URLSearchParams(location.search);

    if (value === null || value === undefined) {
      params.delete(key);
    } else {
      params.set(key, value);
    }

    navigate(`${location.pathname}?${params.toString()}`, options);
  };

  const setParams = (newParams, options = { replace: true }) => {
    const params = new URLSearchParams(location.search);

    Object.entries(newParams).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        params.delete(key);
      } else {
        params.set(key, value);
      }
    });

    navigate(`${location.pathname}?${params.toString()}`, options);
  };

  const deleteParam = (key, options = { replace: true }) => {
    const params = new URLSearchParams(location.search);
    params.delete(key);
    navigate(`${location.pathname}?${params.toString()}`, options);
  };

  return {
    getParam,
    setParam,
    setParams,
    deleteParam,
  };
};
